import { render, staticRenderFns } from "./BudgetMonitoringPoDetail.vue?vue&type=template&id=32ae1c3f&scoped=true"
import script from "./BudgetMonitoringPoDetail.vue?vue&type=script&lang=js"
export * from "./BudgetMonitoringPoDetail.vue?vue&type=script&lang=js"
import style0 from "./BudgetMonitoringPoDetail.vue?vue&type=style&index=0&id=32ae1c3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae1c3f",
  null
  
)

export default component.exports